<template lang="html">
    <div class="container" style="margin-top:10px;margin-bottom:50px;">
        <div class="row">
            <div class="col-sm-12 text-center" style="font-size:32px;font-weight:bold;">
                <img v-if="type" src="images/ajanlat_header.jpg" width="100%" alt="">
                <img v-else src="images/szobafoglalas_header.jpg" width="100%" alt="">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" style="font-size:16px;font-style:italic;margin-top:10px;margin-bottom:10px;">
                <span>Tudja mikor szeretne pihenni de még nem választott a lehetőségek közül?<br />Kérjen ajánlatot tőlünk!<br /><br />Kérjük küldje el ajánlatkérését az alábbi űrlap kitöltésével!</span>
                <span>Kérjük küldje el szobafoglalását az alábbi űrlap kitöltésével.</span>
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Az Ön neve *</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.name" type="text" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Telefonszám *</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.phone" type="text" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Email címe *</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.email" type="text" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Mikor érkezne? *</span>
            </div>
            <div class="col-sm-7">
                <datepicker v-model="object.arrive" format="yyyy. MM. dd." :language="hu"></datepicker>
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Melyik nap távozna? *</span>
            </div>
            <div class="col-sm-7">
                <datepicker v-model="object.leave" format="yyyy. MM. dd." :language="hu"></datepicker>
            </div>
        </div>
        <div class="row panorama-row" v-if="!type">
            <div class="col-sm-5">
                <span>Szobák száma *</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.roomNum" type="number" />
            </div>
        </div>
        <div class="row panorama-row" v-if="!type">
            <div class="col-sm-5">
                <span>Szobák típusa *</span>
            </div>
            <div class="col-sm-7">
                <select v-model="object.roomType" style="width:100%">
                    <option disabled default :value="undefined">Kérem válasszon!</option>
                    <option>Kétágyas</option>
                    <option>Franciaágyas</option>
                    <option>Apartman</option>
                </select>
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Felnőttek száma *</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.adultNum" type="number" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Gyermekek száma</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.childrenNum" type="number" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Gyermekek életkora</span>
            </div>
            <div class="col-sm-7">
                <input v-model="object.childrenAge" type="text" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Megjegyzés</span>
            </div>
            <div class="col-sm-7">
                <textarea v-model="object.comment" style="width:100%;" rows="4"></textarea>
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-5">
                <span>Elfogadom az adatkezelési tájékoztatóban foglaltakat. *</span>
            </div>
            <div class="col-sm-7" style="width:50px;transform: scale(1.5);">
                <input v-model="aszf" type="checkbox" />
            </div>
        </div>
        <div class="row panorama-row">
            <div class="col-sm-12 text-right">
                <button class="my-button"
                style="background-image: url('images/aranysav.jpg');font-size:28px;width:200px;"
                 @click="send()">Küldés</button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" style="font-size:22px; font-weight:bold;margin-top:20px;margin-bottom:20px;">
                <span v-if="type">Az ajánlatkérés nem minősül szobafoglalásnak!</span>
                <span v-else>A szobafoglalás csak a hotel által visszaküldött igazolás esetén érvényes.</span>
            </div>
            <div class="col-sm-12" style="font-size:16px; font-style:italic;">
                <span>Ha kérdése van keressen minket bizalommal a +36 66 547 770-es telefonszámon, vagy a hotel@panoramabekescsaba.hu e-mail címen!</span>
            </div>
        </div>
    </div>

</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Endpoints from '@commons/communication/endpoints.js';
import {hu} from 'vuejs-datepicker/dist/locale'

export default {
    mixins:[Endpoints],
    components: {
        Datepicker
    },
    data:function () {
        return {
            hu,
            type:1, //1:ajanlatkeres, 0:szobafoglalas
            object:{},
            aszf:false,
        };
    },
    created:function () {
        this.type = this.$route.params.type == 'ajanlatkeres'
    },
    methods:{
        send () {
            if (!this.aszf){
                toastr.warning('Az adatkezelési tájékoztató elfogadása kötelező')
                return;
            }

            if (!this.object.name ||
                !this.object.phone ||
                !this.object.email ||
                !this.object.leave ||
                !this.object.arrive ||
                !this.object.adultNum ){
                    toastr.warning('A csillaggal jelölt mezők kitöltése kötelező')
                    return;
                }
            if (!this.type && (!this.object.roomNum || !this.object.roomType)){
                toastr.warning('A csillaggal jelölt mezők kitöltése kötelező')
                return;
            }

            this.object.arrive = this.object.arrive && this.object.arrive.toLocaleDateString("hu-HU")
            this.object.leave = this.object.leave && this.object.leave.toLocaleDateString("hu-HU")

            var self = this;
            this.connSendPanoramaForm(this.object,this.type,function (r) {
                toastr.success('Megkeresését elküldtük.')
                self.object = {}
            },function () {
                toastr.error('Probléma merült fel a küldés során, kérjük próbálja újra.')
            })
        }
    }
}
</script>

<style lang="css">
.panorama-row{
    margin-top:20px;
    font-size: 18px;
}
.panorama-row span{
    font-weight: bold;
}
.panorama-row input{
    width: 100%;
}
.my-button{
    background-size: contain;
    color:black;
    text-transform: uppercase;
    font-size: 14pt;
    border-radius: 0px;
    padding: 8px 16px;
    font-weight: bold;
    width: 100%;
    border-radius: 8px;
    border:none;
    outline:none;
}
</style>



// WEBPACK FOOTER //
// PanoramaForm.vue?dd5d0834